import React from "react";
import { ReactComponent as SparkleIcon } from "@/assets/result/sparkle_icon.svg?react";

interface EmotionSparkleIconProps {
  color: string;
  size?: number;
}

const SparkleIconComponent: React.FC<EmotionSparkleIconProps> = ({
  color,
  size = 16,
}) => <SparkleIcon width={size} height={size} color={color} />;

export default SparkleIconComponent;
